'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moveto = require('moveto');

var _moveto2 = _interopRequireDefault(_moveto);

var _createReducer = require('./createReducer');

var _createReducer2 = _interopRequireDefault(_createReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollToLocation = function scrollToLocation() {
  if (typeof global.window !== 'undefined') {
    var hash = global.window.location.hash;

    if (hash !== '') {
      var retries = 0;
      var id = hash.replace('#', '');
      var scroll = function scroll() {
        retries += 0;
        if (retries > 50) return;
        var element = document.getElementById(id);
        if (element) {
          var moveTo = new _moveto2.default({
            tolerance: 40
          });

          moveTo.move(element);
        } else {
          setTimeout(scroll, 100);
        }
      };
      scroll();
    }
  }
};

function scrollTop(state, action) {
  if (!process.env.REACT_APP_SERVER) {
    if (action.payload.hash) {
      setTimeout(function () {
        return scrollToLocation();
      }, 100);
    } else {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 100);
    }
  }

  return state;
}

var reducer = (0, _createReducer2.default)({}, {
  '@@router/LOCATION_CHANGE': scrollTop
});

exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/scrollReducer.js
// module id = 892
// module chunks = 0